import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { FontAwesome } from '@expo/vector-icons';

//=========================================================================

const MySiteAndStudyHeader = ( { width, actionsColumnWidth=90, arrTitles, onHeaderPressed, language } ) => {

    var showIcon = false
    var showGrey = false

    return (
        <View style={{width:width,height:30,backgroundColor:'#fff',flexDirection:'row',borderRadius:5,
        }}>

            <TouchableOpacity style={{flex:0.3,height:30,justifyContent:'center',backgroundColor:'#fff'}} key={arrTitles[0]} disabled={!showIcon} onPress={() => {onHeaderPressed(arrTitles[0]);}} >
                <Text numberOfLines={1} ellipsizeMode='tail' style={{
                    textAlign:'left',
                    marginLeft:8, marginRight:8,
                    fontFamily: "Rubik-Medium",
                    fontSize: 14,
                    color: "#001a2f",
                    }} >{arrTitles[0]}{showIcon?<FontAwesome name="sort" style={{fontSize:16,color:showGrey?'#d9d9d9':'#797979',marginLeft:6,marginTop:5}} />:null}</Text>
            </TouchableOpacity>

            <TouchableOpacity style={{flex:0.7,height:30,justifyContent:'center',backgroundColor:'#fff'}} key={arrTitles[1]} disabled={!showIcon} onPress={() => {onHeaderPressed(arrTitles[1]);}} >
                <Text numberOfLines={1} ellipsizeMode='tail' style={{
                    textAlign:'left',
                    marginLeft:8, marginRight:8,
                    fontFamily: "Rubik-Medium",
                    fontSize: 14,
                    color: "#001a2f",
                    }} >{arrTitles[1]}{showIcon?<FontAwesome name="sort" style={{fontSize:16,color:showGrey?'#d9d9d9':'#797979',marginLeft:6,marginTop:5}} />:null}</Text>
            </TouchableOpacity>

            <TouchableOpacity style={{width:140,height:30,justifyContent:'center',backgroundColor:'#fff'}} key={arrTitles[2]} disabled={!showIcon} onPress={() => {onHeaderPressed(arrTitles[2]);}} >
                <Text numberOfLines={1} ellipsizeMode='tail' style={{
                    textAlign:'center',
                    fontFamily: "Rubik-Medium",
                    fontSize: 14,
                    color: "#001a2f",
                    }} >{arrTitles[2]}{showIcon?<FontAwesome name="sort" style={{fontSize:16,color:showGrey?'#d9d9d9':'#797979',marginLeft:6,marginTop:5}} />:null}</Text>
            </TouchableOpacity>

            <View style={{width:actionsColumnWidth,height:30,justifyContent:'center',backgroundColor:'#fff'}} key={'actions'} />

        </View>
    );
};

export default MySiteAndStudyHeader;